<app-custom-simu *ngIf="selMode === reportMode.simu" [customReport]="report"></app-custom-simu>
<app-custom-compare *ngIf="selMode === reportMode.compare" [customReport]="report"></app-custom-compare>
